import storage from './storage';

export default {
  timestampToTime(timestamp) {
    const date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    const Y = date.getFullYear() + '-';
    const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
    const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
    const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
    return Y + M + D + h + m + s;
  },
  // 时间戳转换成年-月-日-时-分格式
  timestampToYMDHM(timestamp) {
    const date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    const Y = date.getFullYear() + '-';
    const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
    const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
    return Y + M + D + h + m;
  },
  // 时间戳转换成月-日-时-分格式
  timestampToMDHM(timestamp) {
    const date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    const Y = date.getFullYear() + '-';
    const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
    const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
    return M + D + h + m;
  },
  // 时间戳转换成年-月-日-时-分-秒格式
  timestampToYMD(timestamp) {
    const date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    const Y = date.getFullYear() + '-';
    const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
    const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
    const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
    return Y + M + D;
  },
  // 时间戳转换成年-月-日-时-分-秒格式
  timestampToTimeFont(timestamp) {
    const date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    const Y = date.getFullYear() + '年';
    const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '月';
    const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
    const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
    const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
    return Y + M;
  },
  // 时间戳转换成月-日 时分秒格式
  timestampToTimeFontMDhms(timestamp) {
    const date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    const Y = date.getFullYear() + '';
    const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '月';
    const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + '日';
    const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
    const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
    return M + D + h + m + s;
  },
  // 时间戳转换成月-日格式
  timestampToTimeFontMD(timestamp) {
    const date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    const Y = date.getFullYear() + '';
    const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '月';
    const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + '日';
    const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
    const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
    return M + D;
  },
  // 时间戳转换成月-日格式
  timestampToTimeFontMD2(timestamp) {
    const date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    const Y = date.getFullYear() + '';
    const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '/';
    const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate());
    const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
    const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
    return M + D;
  },
  // 时间戳转换成时-分格式
  timestampToTimeFontHM(timestamp) {
    const date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    const Y = date.getFullYear() + '';
    const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '';
    const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + '';
    const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + '';
    const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
    return h + m;
  },

  // 将中国标准时间转成年-月-日格式
  formatDate(date) {
    const y = date.getFullYear();
    let m = date.getMonth() + 1;
    m = m < 10 ? '0' + m : m;
    let d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    return y + '-' + m + '-' + d;
  },

  //计算两个时间相差天数
  datedifference(sDate1, sDate2) { //sDate1和sDate2是yyyy-mm-dd格式
    let dateSpan,
      tempDate,
      iDays;
    sDate1 = Date.parse(sDate1);
    sDate2 = Date.parse(sDate2);
    dateSpan = sDate2 - sDate1;
    dateSpan = Math.abs(dateSpan);
    iDays = Math.floor(dateSpan / (24 * 3600 * 1000));
    return iDays;
  },

  //N天前期间  eg 90天前 AddDayCount =-90; 90天后 AddDayCount= 90    getDateStr和checkDate一起用  日期大于90天或者N天
  getDateStr(date, AddDayCount) {
    const dd = new Date(date);
    dd.setDate(dd.getDate() + AddDayCount);//获取AddDayCount天后的日期
    const y = dd.getFullYear();
    const m = (dd.getMonth() + 1) < 10 ? '0' + (dd.getMonth() + 1) : (dd.getMonth() + 1);//获取当前月份的日期，不足10补0
    const d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();//获取当前几号，不足10补0
    return y + '-' + m + '-' + d;
  },

  checkDate(date1, date2) {
    const oDate1 = new Date(date1);
    const oDate2 = new Date(date2);
    if (oDate1.getTime() > oDate2.getTime()) {
      return true;
    } else {
      return false;
    }
  },

  // 将数据为null，为空，为undefind做处理
  remarkText(text) {
    if (text === '' || text === null || text === undefined) {
      return '--';
    } else {
      return text;
    }
  },

  // 城市格式化
  arrToStr(arr) {
    let result = '';
    if (arr && arr.length > 0) {
      arr.forEach(ele => {
        const ids = ele.join('_');
        result += ids + ',';
      });
      result = result.substring(0, result.length - 1);
    }

    return result;
  },
  strtoArr(arr) {
    const result = [];
    const ids = arr.split(',');
    ids.forEach(el => {
      const _id = el.split('_');
      result.push(_id);
    });
    return result;
  },

  // 标签管理过滤
  findArray(dic, key, value) {
    for (let i = 0; i < dic.length; i++) {
      if (dic[i][key] == value) {
        return i;
      }
    }
    return -1;
  },

  // 显示手机号码中间4位*号[telphone-133****1234]
  filterPhone: function (value) {
    if (value !== undefined) {
      let start = value.substring(0, 3),
        end = value.substring(7, 11);
      return start + '****' + end;
    }
  },

  // 过滤HTML标签
  htmlfilter: function (msg) {
    if (msg) {
      let msg = msg.replace(/<\/?[^>]*>/g, ''); //去除HTML Tag
      msg = msg.replace(/[|]*\n/, ''); //去除行尾空格
      msg = msg.replace(/&npsp;/ig, ''); //去掉npsp
      return msg;
    }
  },

  // 金额换算
  calcPrice(m, float = true) {
    if (!parseInt(m)) {
      return '0.00';
    }
    let num = Math.round((m / 100) * 100) / 100;
    return float ? num.toFixed(2) : num;
  },

  calcPriceL(m, float = true) {
    if (!parseInt(m)) {
      return '0';
    }
    let num = Math.round((m / 100) * 100) / 100;
    return float ? num : num;
  },

  // 将传入的obj整成数组，再返回相应的值[主要用于select计算[普通select-val-txt]
  optionTxt: function (value, obj) {
    let newObj = {};
    let checkVal = /请选择/;
    if (checkVal.test(value) || value === '') {
      return value;
    } else {
      for (let i = 0; i < obj.length; i++) newObj[obj[i].val] = obj[i].txt;
      return newObj[value];
    }
  },
  //保留几位小数（四舍五入）num是数值，n是保留几位
  getFloat(num, n) {
    n = n ? parseInt(n) : 0;
    if (n <= 0) {
      return Math.round(num);
    }
    num = Math.round(num * Math.pow(10, n)) / Math.pow(10, n); //四舍五入
    num = Number(num)
      .toFixed(n); //补足位数
    return num;
  },
  customerService() {
    window.location.href = 'tel:4006424887';
  },
  /**
   * 返回数组中对应key的值
   * arrayTemp 格式 [
   *     {label:"", value:""}
   * ]
   */
  arrayFomatter(val, arrayTemp) {
    let str = '';
    for (let i = 0, max = arrayTemp.length; i < max; i++) {
      if (arrayTemp[i].value == val) {
        str = arrayTemp[i].label;
        break;
      }
    }
    return str;
  },
  //手机设备号UUID
  getUUID(e) {
    let uuid;
    uuid = storage.get('deviceId');
    if (!uuid) {
      var d = new Date().getTime();
      uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
      });
      storage.set('deviceId', uuid);
    }
    return uuid;
  },
  //版本号的比较
  //假设版本号为非空字符串，并且只包含数字和 . 字符。这种情形下比较两个版本号 version1 和 version2，如果 version1 > version2 返回 1，如果 version1 < version2 返回 -1， 除此之外返回 0。
  compareVersion(version1, version2) {
    const arr1 = version1.split('.');
    const arr2 = version2.split('.');
    const length1 = arr1.length;
    const length2 = arr2.length;
    const minlength = Math.min(length1, length2);
    let i = 0;
    for (i; i < minlength; i++) {
      let a = parseInt(arr1[i]);
      let b = parseInt(arr2[i]);
      if (a > b) {
        return 1;
      } else if (a < b) {
        return -1;
      }
    }
    if (length1 > length2) {
      for (let j = i; j < length1; j++) {
        if (parseInt(arr1[j]) != 0) {
          return 1;
        }
      }
      return 0;
    } else if (length1 < length2) {
      for (let j = i; j < length2; j++) {
        if (parseInt(arr2[j]) != 0) {
          return -1;
        }
      }
      return 0;
    }
    return 0;
  },
  // 时间戳转换成天-时-分-秒格式
  formatDuring(second) {
    const days = Math.floor(second / 86400);
    const hours = Math.floor((second % 86400) / 3600);
    const minutes = Math.floor(((second % 86400) % 3600) / 60);
    const seconds = Math.floor(((second % 86400) % 3600) % 60);
    // const forMatDate = { days: days, hours: hours, minutes: minutes,seconds: seconds};
    return days ? (days + '天') : '' + (hours ? ((hours < 10 ? ('0' + hours) : hours) + '时') : '') + (minutes < 10 ? ('0' + minutes) : minutes) + '分' + (seconds < 10 ? ('0' + seconds) : seconds) + '秒';
  },
  formatDuringDHMS(second) {
    const days = Math.floor(second / 86400);
    const hours = Math.floor((second % 86400) / 3600);
    const minutes = Math.floor(((second % 86400) % 3600) / 60);
    const seconds = Math.floor(((second % 86400) % 3600) % 60);
    // const forMatDate = { days: days, hours: hours, minutes: minutes,seconds: seconds};
    return days ? (days + ':') : '' + (hours ? ((hours < 10 ? ('0' + hours) : hours) + ':') : '') + (minutes < 10 ? ('0' + minutes) : minutes) + ':' + (seconds < 10 ? ('0' + seconds) : seconds);
  },

  //http图片转base64
  imageUrlToBase64(img) {
    //一定要设置为let，不然图片不显示
    let image = new Image();
    let dataURL = '';
    //解决跨域问题
    image.setAttribute('crossOrigin', 'anonymous');
    let imageUrl = img;
    image.src = imageUrl;
    //image.onload为异步加载
    return new Promise((resolve) => {
      image.onload = () => {
        let canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;
        let context = canvas.getContext('2d');
        context.drawImage(image, 0, 0, image.width, image.height);
        let quality = 0.8;
        //这里的dataurl就是base64类型
        // dataURL = canvas.toDataURL('image/jpeg', quality); //使用toDataUrl将图片转换成jpeg的格式,不要把图片压缩成png，因为压缩成png后base64的字符串可能比不转换前的长！
        dataURL = canvas.toDataURL('image/png', quality); //使用toDataUrl将图片转换成jpeg的格式,不要把图片压缩成png，因为压缩成png后base64的字符串可能比不转换前的长！
        resolve(dataURL);
      };
    });
  },

  //过滤对象属性的空值--方法一
  filterNullValueObject(obj) {
    for (const i in obj) {
      if (obj[i] === '' || obj[i] === null || obj[i] === 'null') {
        delete obj[i];
      }
    }
    return obj;
  },
  //过滤对象属性的空值--方法二--这个方法不会影响原来的对象，而是返回一个新对象
  filterParams(obj) {
    let _newPar = {};
    for (let key in obj) {
      if ((obj[key] === 0 || obj[key] === false || obj[key]) && obj[key].toString()
        .replace(/(^\s*)|(\s*$)/g, '') !== '') {
        _newPar[key] = obj[key];
      }
    }
    return _newPar;
    },
    // 中国标椎时间转换为年月日时分秒
    formatDateAll(date, fmt) {
        if (/(y+)/.test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        const o = {
            'M+': date.getMonth() + 1,
            'd+': date.getDate(),
            'h+': date.getHours(),
            'm+': date.getMinutes(),
            's+': date.getSeconds()
        };
        for (const k in o) {
            if (new RegExp(`(${k})`).test(fmt)) {
            const str = o[k] + '';
            fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : this.padLeftZero(str))
            }
        }
        return fmt
    },
    padLeftZero(str) {
        return ('00' + str).substr(str.length)
    },
    newDateAll(time) {
        var date = new Date(time)
        var y = date.getFullYear()
        var m = date.getMonth() + 1
        m = m < 10 ? '0' + m : m
        var d = date.getDate()
        d = d < 10 ? '0' + d : d
        var h = date.getHours()
        h = h < 10 ? '0' + h : h
        var minute = date.getMinutes()
        minute = minute < 10 ? '0' + minute : minute
        var s = date.getSeconds()
        s = s < 10 ? '0' + s : s
        return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + s
    }
};
